import type { JSX } from 'react';
import type { SurfaceOf } from './types';
import { formatDate } from './format';
import { useT } from '../i18n/useT';

export function ClinicalNoteSurfaceView({ surface }: { surface: SurfaceOf<'clinical-note'> }): JSX.Element {
  const t = useT();
  return (
    <section className="surface surface-note">
      <header className="note-header">
        <h3 className="surface-title">{surface.title ?? 'Clinical note'}</h3>
        <span className={`chip ${surface.status.toLowerCase() === 'signed' ? 'chip-good' : 'chip-warn'}`}>{surface.status}</span>
        {surface.author ? (
          <span className="muted small">
            {t('author')}: {surface.author}
          </span>
        ) : null}
        {surface.date ? (
          <span className="muted small">
            {t('date')}: {formatDate(surface.date)}
          </span>
        ) : null}
      </header>
      <pre className="note-body">{surface.body}</pre>
      {surface.noteId ? <p className="muted small">{surface.noteId}</p> : null}
    </section>
  );
}
